import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
    { to: '/inbox', icon: '📥', label: "收件箱" },
    { to: '/campaigns', icon: '🎯', label: "获客活动" },
    { to: '/bulk-send', icon: '📨', label: "批量发送" },
    { to: '/internal-send', icon: '🧪', label: "内部测试" },
    { to: '/contacts', icon: '👤', label: "联系人" },
    { to: '/domains', icon: '🌐', label: "域名与账号" },
    { to: '/warmup', icon: '🔥', label: "邮箱预热" },
];

interface SidebarProps {
    unreadCount: number;
    previewMode?: boolean;
}

export function Sidebar({ unreadCount, previewMode = false }: SidebarProps) {
    return (
        <aside className="app-sidebar">
            <div className="sidebar-brand">
                <h1>⚡ LawHelper 获客管理</h1>
                <p>客户发现与邮件触达</p>
            </div>

            <nav className="sidebar-nav">
                {NAV_ITEMS.map((item) => previewMode && !['/bulk-send', '/internal-send'].includes(item.to) ? (
                    <span key={item.to} className="nav-item preview-disabled" title="本地预览暂不支持此操作">
                        <span className="nav-icon">{item.icon}</span>
                        {item.label}
                    </span>
                ) : (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                    >
                        <span className="nav-icon">{item.icon}</span>
                        {item.label}
                        {item.to === '/inbox' && unreadCount > 0 && (
                            <span className="nav-badge">{unreadCount}</span>
                        )}
                    </NavLink>
                ))}
            </nav>

            <div style={{ padding: '12px 16px', borderTop: '1px solid var(--border-default)' }}>
                <div style={{ fontSize: 11, color: 'var(--text-dim)' }}>
                    v1.0 · Acquisition Engine
                </div>
            </div>
        </aside>
    );
}
